import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const values = [
  {
    name: 'Kurasi',
    description: 'Setiap build diarahkan supaya pemilihan lampu, part, dan finishing terasa relevan dengan karakter kendaraan.'
  },
  {
    name: 'Presisi',
    description: 'Fokus pengerjaan ada pada detail visual, hasil pemasangan yang rapi, dan kualitas output yang enak dilihat sekaligus dipakai.'
  },
  {
    name: 'Arah Brand',
    description: 'XSignature dibangun untuk kebutuhan custom projector headlamp, foglamp, detailing, body kit, dan lini parts performance pilihan.'
  }
];

const About = () => {
  return (
    <div className="min-h-screen bg-white pt-[72px]">
      <section className="bg-slate-950 py-24 text-white">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[0.95fr_1.05fr] lg:px-8">
          <div className="max-w-2xl">
            <h1 className="mt-6 text-4xl font-bold leading-tight md:text-5xl">
              XSignature fokus pada custom lampu, detailing, dan upgrade parts kendaraan.
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-300">
              Arahnya bukan bengkel umum. Brand ini diposisikan untuk custom projector headlamp dan foglamp,
              coating, detailing, body kit, lampu aftermarket, serta pilihan produk seperti Profender, YSS, JS1, HKS, dan UR.
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link to="/services" className="btn btn-primary px-8">
                Lihat Layanan <FiArrowRight className="ml-2" />
              </Link>
              <Link to="/contact" className="btn btn-outline px-8">
                Hubungi Kami
              </Link>
            </div>
          </div>

          <div className="flex items-end">
            <img
              src="/media/instagram/about-lexus-rx270.jpg"
              alt="Upgrade headlamp dan foglamp Lexus RX270 dari Instagram XSignature"
              className="h-[320px] w-full object-cover lg:h-[460px]"
            />
          </div>
        </div>
      </section>

      <section className="border-b border-slate-200 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">
              Yang ditonjolkan adalah spesialisasi, detail pengerjaan, dan pilihan produk yang tepat.
            </h2>
          </div>

          <div className="mt-14 border-t border-slate-200">
            {values.map((value, index) => (
              <div
                key={value.name}
                className={`grid gap-4 py-7 md:grid-cols-[220px_1fr] ${
                  index !== values.length - 1 ? 'border-b border-slate-200' : ''
                }`}
              >
                <div className="text-xl font-semibold text-slate-950">{value.name}</div>
                <p className="max-w-2xl text-base leading-8 text-slate-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-[1fr_auto] md:items-end lg:px-8">
          <div className="max-w-2xl">
            <h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">
              Siap konsultasi untuk project kendaraan Anda?
            </h2>
            <p className="mt-4 text-base leading-8 text-slate-600">
              Kami siap membantu menentukan arah upgrade, mulai dari lighting setup sampai pemilihan suspension dan parts pendukung.
            </p>
          </div>
          <Link to="/contact" className="btn btn-primary px-8">
            Hubungi Kami <FiArrowRight className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
